/**
 * EventRecurrenceRow
 *
 * Shows recurrence status and opens picker.
 * Google Calendar style with icon on left.
 */

import { StyleSheet, Text, TouchableOpacity, View } from 'react-native';
import { Ionicons } from '@expo/vector-icons';
import { Colors } from '@/constants/theme';
import { Spacing } from '@/constants/spacing';
import { getBodyFont } from '@/constants/typography';
import type { RecurrenceRule } from '@/types/events';
import { RecurrenceRuleBuilder } from '@/lib/calendar/RecurrenceRuleBuilder';

type EventRecurrenceRowProps = {
  value: RecurrenceRule | null;
  onPress: () => void;
  palette: typeof Colors.light;
};

export function EventRecurrenceRow({ value, onPress, palette }: EventRecurrenceRowProps) {
  return (
    <TouchableOpacity style={styles.container} onPress={onPress}>
      <View style={styles.iconContainer}>
        <Ionicons name="repeat-outline" size={18} color={palette.textMuted} />
      </View>
      <View style={styles.content}>
        <Text style={[styles.label, { color: palette.text, fontFamily: getBodyFont() }]}>
          {value ? RecurrenceRuleBuilder.humanizeRRule(value) : 'Does not repeat'}
        </Text>
      </View>
      <Ionicons name="chevron-forward" size={16} color={palette.textMuted} />
    </TouchableOpacity>
  );
}

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: Spacing.lg,
    paddingVertical: Spacing.md + 2, // 14px
  },
  iconContainer: {
    width: 40,
    alignItems: 'center',
  },
  content: {
    flex: 1,
  },
  label: {
    fontSize: 14,
  },
});
